/** Build page list with ellipsis, e.g. [1, '...', 4, 5, 6, '...', 46] (1-based page numbers). */
export function getVisiblePages(currentPage1Based, totalPages, siblingCount = 1) {
  const total = Math.max(1, Number(totalPages) || 1);
  const current = Math.min(Math.max(1, Number(currentPage1Based) || 1), total);
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const pages = new Set([1, total]);
  for (let p = current - siblingCount; p <= current + siblingCount; p += 1) {
    if (p >= 1 && p <= total) pages.add(p);
  }
  // Keep edges denser when near start/end
  if (current <= 3) {
    pages.add(2); pages.add(3); pages.add(4);
  }
  if (current >= total - 2) {
    pages.add(total - 1); pages.add(total - 2); pages.add(total - 3);
  }

  const sorted = Array.from(pages).sort((a, b) => a - b);
  const result = [];
  let prev = 0;
  for (const p of sorted) {
    if (prev && p - prev > 1) result.push('...');
    result.push(p);
    prev = p;
  }
  return result;
}
